// extracted by mini-css-extract-plugin
module.exports = {"wrapBtn":"cardEditing_wrapBtn__2Nbfm","editingWrp":"cardEditing_editingWrp__EncmD","createQuest":"cardEditing_createQuest__2UPE8"};